import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import ThemeProvider       from '@mui/system/ThemeProvider';
import createTheme         from '@mui/material/styles/createTheme';
import responsiveFontSizes from '@mui/material/styles/responsiveFontSizes';

const defaultTheme = responsiveFontSizes(createTheme({
  palette: {
    type: 'light',
    background: {
      paper: '#fff',
      dark:  '#F8F9FA',
      light: '#D8D8D8',
    },
    primary: {
      main: '#5BC668',
      contrastText: '#192C39',
      light: '#E8F3EB',
    },
    secondary: {
      main:     '#192C39',
      contrastText: '#192C39',
      disabled: '#6D7278',
    },
    error: {
      main: '#f44336',
    },
  },
  typography: {
    // htmlFontSize: 10,
    // fontSize: 14,
    h1: {
      fontSize: '2.75rem',
    },
    h2: {
      fontSize: '2.125rem',
    },
    h3: {
      fontSize: '1.5rem',
    },
    h4: {
      fontSize: '1.25rem',
    },
    h5: {
      fontSize: '1rem',
    },
    h6: {
      fontSize: '.825rem',
    },
    button: {
      textTransform: 'none'
    }
  },
}));

function theme(){
  try {
    const eostheme = document.getElementById('eostheme');
    if ( !eostheme ) return defaultTheme;
    return responsiveFontSizes(createTheme(
      JSON.parse(eostheme.text)
    ));
  } catch(e) {
    console.error('eostheme', 'failed', e);
    return defaultTheme;
  }
}

function AppTheme({ children }) {
  return (
    <Fragment>
      <ThemeProvider theme={theme()}>
        {children}
      </ThemeProvider>
    </Fragment>
  );
}

AppTheme.defaultProps = {

};

AppTheme.propTypes = {

};

export default AppTheme;
